import React from "react";
import { IBanner } from "@/store/home/homeModel";
import { OptimizedImage } from "@/components/common/OptimizedImage";

const Banner = ({ BannerList }: { BannerList: IBanner[] }) => {
  if (!BannerList[0]) return null;
  return (
    <section className="relative h-[60vh] flex items-center justify-center overflow-hidden mt-24">
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60 z-10" />
      <div className="absolute inset-0 z-0">
        <OptimizedImage
          src={BannerList[0]?.BannerImage}
          alt={BannerList[0]?.BannerTitle || "Aranya Banner"}
          fill
          priority
          className="object-cover animate-slow-zoom"
        />
      </div>
      <div className="relative z-20 text-center px-6">
        <h1 className="text-white mb-6 drop-shadow-2xl">
          {BannerList[0]?.BannerTitle || "Aranya"}
        </h1>
        <p className="text-white/90 text-xl max-w-2xl mx-auto">
          {BannerList[0]?.Description || "Where wilderness meets comfort, and every moment connects you with nature."}
        </p>
      </div>
    </section>
  );
};

export default Banner;
